import {BaseMuWidget} from "./BaseMuWidget";
import {MuEvent, MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {ColumnInfo, UiTable, UiTableCell} from "./components/UiTable";
import {TicketsCL} from "./generated/TicketsCL";
import {MuBinder} from "mu-widget/lib/MuBinder";

export class AttachList extends BaseMuWidget {
    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        list: UiTable,
    }>;
    beforeIndex() {
        this.muAppendContent(`<table mu="list:UiTable" class="table table-striped table-hover table-sticky-header tbody-_td-_a">
            <tr>
                <td mu=":UiTableCell@actions">
                    <span class="icon-before-remove" mu="bRemove">odstranit</span>
                    <span class="icon-before-remove" mu="bDownload">stáhnout</span>
                </td>
            </tr>
        </table>
        <div mu="pPreview">
            <div class="attaches__preview">
                <div mu-id="preview"></div>
            </div>
            <div class="buttons" mu-id="previewButtons">
                <a target="_blank" class="btn-icon btn-icon-size-3 icon-before-download" mu-id="bDownload">Stáhnout</a>
                <span class="btn-icon btn-icon-size-3 icon-before-close" mu-id="bClosePreview">Zavřít náhled</span>
            </div>
        </div>`);
    }

    afterIndex() {
        this.bClosePreview_click();
    }

    protected cl = new TicketsCL();

    protected ids: Record<string, number> = { foo: 42 };

    async bindData(ids: Record<string, number>|null = null) {
        ids = ids || this.ids;
        this.ids = ids;
        const self = this;
        this.muNamedWidget.list.columns = [
            new ColumnInfo({ field: "fileName", name: "Název", orderable: false, filterable: false }),
            new ColumnInfo({ field: "fileSize", name: "Velikost", orderable: false, filterable: false }),
            // new ColumnInfo({ field: "description", name: "", orderable: false, isFiltered: false }),
            new ColumnInfo({ field: "typeTitle", name: "Type", orderable: false, filterable: false }),
            new ColumnInfo({ field: "dtAdd", name: "Přidáno", orderable: false, filterable: false,
                transformContent: (value, columnInf, cell, ev) => MuBinder.filters.dateTime(value)
            }),
        ];
        this.muNamedWidget.list.rowParams = { }
        this.muNamedWidget.list.data = await this.cl.withMessage("Načítám přílohy", this.container)
            .findAttachesFor(ids);
        this.muNamedWidget.list.render();
    }

    async list_rowClick(ev:MuEvent, row: MuWidget&{data:any}) {
        this.muVisible(true, 'pPreview');
        (this.ui.bDownload as unknown as HTMLAnchorElement).href = row.data.downloadLink;
        const data = await this.cl.withMessage("Načítám náhled", this.ui.preview).getAttachDetail(row.data.id, null);
        this.ui.preview.innerHTML = data;
    }

    bClosePreview_click() {
        this.muVisible(false, 'pPreview');
    }

    hasAnyAttach() {
        return this.muNamedWidget.list.data.length > 0;
    }
}

export class AttachListActions extends UiTableCell {

}